<ng-container *transloco="let t">
  <main class="sso-auth">
    <img
      class="sso-auth__logo"
      src="/assets/images/lifespeak_brand_logo.svg"
      alt="LifeSpeak"
      data-test-id="ssoAuth.logo"
    />

    @if (requiresManualLaunch()) {
      <h1 class="sso-auth__title heading-t5" data-test-id="ssoAuth.title">
        {{ t('ssoAuth.title') }}
      </h1>

      <p class="sso-auth__body text-b2" data-test-id="ssoAuth.body">
        {{ t('ssoAuth.body') }}
      </p>

      <!--
        Must be an <a> with a real href. Universal Links / App Links only
        fire when iOS / Android observe a user-initiated tap on an anchor;
        a <button> with a click handler that sets window.location.href is
        treated as programmatic navigation and does not trigger the app.
      -->
      <a
        class="sso-auth__cta"
        [href]="launchUrl()"
        rel="noopener"
        data-test-id="ssoAuth.continueButton"
      >
        {{ t('ssoAuth.continueButton') }}
      </a>

      <p class="sso-auth__hint" data-test-id="ssoAuth.closeHint">
        {{ t('ssoAuth.closeHint') }}
      </p>
    }
  </main>
</ng-container>
